<template>
  <div id="app">
    <Layout class="app-layout">
      <Header :style="{position: 'fixed', width: '100%'}">
        <TopBar />
      </Header>
      <Content class="app-content" :style="{margin: '50px 0 0', background: '#fff', minHeight: '500px'}">
        <router-view></router-view>
      </Content>
    </Layout>
  </div>
</template>

<script>
import { TopBar } from "./components";
import { Layout, Content, Header } from 'view-design';

export default {
  components: {
    TopBar,
    Layout,
    Content,
    Header
  },
  name: "app",
  data() {
    return {
      login: false
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  overflow: auto;
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000;
    width: 100%;
    height: 100%;
    position: relative;

    .app-layout {
      height: 100%;
      .ivu-layout-header {
        height: 50px;
        padding: 0;
        background-color: #fff;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
        z-index: 2;
        line-height: 50px;
      }
    }
    .app-content {
      z-index: 1;
    }
    .bgcolor {
      background: #f7f7f7;
    }
    .content-wrapper {
      z-index: 1;
      width: 100%;
      flex-grow: 1;
      overflow: hidden;
    }
    .left {
      text-align: left;
    }
    .center {
      text-align: center;
    }
    .pd {
      padding: 10px;
    }
    .btn-width {
      margin-right: 15px;
      width: 104px;
      height: 32px;
      padding: 6px 10px;
      line-height: 18px;
      font-size: 14px;
    }
  }
}
</style>
